export default "__VITE_PUBLIC_ASSET__abbd267c__"